// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-c"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 19H9C8.44772 19 8 18.5523 8 18V6C8 5.44772 8.44772 5 9 5H16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersCIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-c',
    ref,
    icon: element,
  },
));

LettersCIcon.displayName = 'LettersCIcon';

export default LettersCIcon;
